import React from "react";

const EvaluateInventory = () => <div className="content"><h2>Evaluate Inventory</h2></div>;

export default EvaluateInventory; 